import React, { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Eye } from "lucide-react";
import api from "@/lib/api";

const fmt = (n) => new Intl.NumberFormat("en-IN").format(n);

const Range = ({ label, d, testid }) => (
  <div className="rounded-lg border border-white/10 bg-[#0f1a35] p-4" data-testid={testid}>
    <div className="text-[11px] uppercase tracking-wider text-zinc-400 mb-1">{label}</div>
    <div className="font-display text-3xl font-bold text-zinc-50" data-testid={`${testid}-total`}>{fmt(d.total)}</div>
    <div className="text-[11px] text-zinc-500 mt-1">
      <span className="text-sky-300" data-testid={`${testid}-anonymous`}>{fmt(d.anonymous)} not signed in</span> · <span className="text-pink-300" data-testid={`${testid}-signed`}>{fmt(d.signed_in)} signed in</span>
    </div>
  </div>
);

export const VisitorsCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/analytics/visitors").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;

  return (
    <div className="rounded-lg border border-white/10 bg-[#152040] p-5 mb-6" data-testid="admin-visitors-card">
      <div className="text-[11px] uppercase tracking-wider text-pink-300 flex items-center gap-2 mb-4">
        <Eye className="w-3.5 h-3.5" /> Unique visitors
      </div>
      <div className="grid sm:grid-cols-3 gap-3 mb-5">
        <Range label="Today" d={data.today} testid="visitors-today" />
        <Range label="Last 7 days" d={data.last_7_days} testid="visitors-7d" />
        <Range label="Last 30 days" d={data.last_30_days} testid="visitors-30d" />
      </div>
      <div className="h-48" data-testid="visitors-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data.series} margin={{ left: -20, right: 4 }}>
            <XAxis dataKey="date" tickFormatter={(d) => d.slice(5)} tick={{ fill: "#71717a", fontSize: 10 }} interval={4} axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} tick={{ fill: "#71717a", fontSize: 10 }} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: "rgba(255,255,255,0.04)" }} contentStyle={{ background: "#0b1428", border: "1px solid rgba(255,255,255,0.1)", fontSize: 12 }} />
            <Bar dataKey="anonymous" name="Not signed in" stackId="v" fill="#7dd3fc" />
            <Bar dataKey="signed_in" name="Signed in" stackId="v" fill="#f9a8d4" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="text-[10px] text-zinc-500 mt-2">Each browser is counted once per day. A visitor who later signs in is counted under their account.</div>
    </div>
  );
};
